import React from "react";
import cx from "classnames";
//
import { genders } from "../config";
import Screen from "./ConnectedScreen";
import CityButton from "../components/CityButton";

const GenderScreen = ({ value, genderChanged, goTo, genders }) => (
  <Screen title="Select gender" isActive onNext={(ev) => goTo("outcall")}>
    {genders.map((gender) => {
      return (
        <CityButton
          key={gender.id}
          name={gender.name}
          full
          className={cx({
            active: gender.id === value,
          })}
          onClick={(ev) => genderChanged(gender.id)}
        />
      );
    })}
  </Screen>
);

// @connect
import { bindActionCreators as bindActions } from "redux";
import { connect } from "react-redux";
//
import { setGenderAction } from "../modules/booking/actions";

const state = ({ booking }) => ({
  value: booking.genderId,
  genders,
});

const actions = (dispatch) =>
  bindActions({ genderChanged: setGenderAction }, dispatch);

export default connect(
  state,
  actions
)(GenderScreen);
